import './chapters.css'
import PlanoSenior from '../../images/planosenior.png'
import ComingSoon from '../../images/coming.png'
import PlanoWest from '../../chapterimages/planowest.png'
import Allen from '../../chapterimages/allen.png'
import BookerT from '../../chapterimages/bookert.png'
import Centennial from '../../chapterimages/centennial.png'
import Clark from '../../chapterimages/clark.png'
import Coppell from '../../chapterimages/coppell.png'
import Evergreen from '../../chapterimages/evergreen.png'
import FlowerMound from '../../chapterimages/flowermound.png'
import GreenLevel from '../../chapterimages/greenlevel.png'
import Heritage from '../../chapterimages/heritage.png'
import Hockaday from '../../chapterimages/hockaday.png'
import Independence from '../../chapterimages/independence.png'
import LagunaCreek from '../../chapterimages/lagunacreek.png'
import Liberty from '../../chapterimages/liberty.png'
import LoneStar from '../../chapterimages/lonestar.png'
import McMillen from '../../chapterimages/mcmillen.png'
import Minnesota from '../../chapterimages/minnesota.png'
import PantherCreek from '../../chapterimages/panthercreek.png'
import Paramus from '../../chapterimages/paramus.png'
import Ranchview from '../../chapterimages/ranchview.png'
import Vines from '../../chapterimages/vines.png'
import Wakeland from '../../chapterimages/wakeland.png'
import WilliamB from '../../chapterimages/williamb.png'
import WylieEast from '../../chapterimages/wylieeast.png'
import GOHS from '../../eventimages/gohs.png'
import PESH from '../../chapterimages/pesh.png'

import { Card, CardList } from '../../component/card'
export const Chapters = () =>{
    const schoolCards = [
  {
    title: 'Plano East Senior High School',
    subtitle: '',
    imageUrl: PESH,
    description: 'Plano East Senior High School\nPresident: Ayan Mishra',
    'data-id': 'plano-east'
  },
  {
    title: 'Great Oak High School',
    subtitle: '',
    imageUrl: GOHS,
    description: 'Great Oak High School\nPresidents: Yong Kang, Caidyn Kim',
    'data-id': 'great-oak'
  },
  {
    title: 'Plano Senior High School',
    subtitle: '',
    imageUrl: PlanoSenior,
    description: 'Plano Senior High School\nPresident: Benedict Premilan',
    'data-id': 'plano-senior'
  },
  {
    title: 'McMillen High School',
    subtitle: '',
    imageUrl: McMillen,
    description: 'McMillen High School\nPresident: Cody Trainer',
    'data-id': 'mcmillen'
  },
  {
    title: 'Flower Mound High School',
    subtitle: '',
    imageUrl: FlowerMound,
    description: 'Flower Mound High School\nPresident: Dhruv Pabari',
    'data-id': 'flower-mound'
  },
  {
    title: 'Clark High School',
    subtitle: '',
    imageUrl: Clark,
    description: 'Clark High School\nPresident: Dharshana Balaji',
    'data-id': 'clark'
  },
  {
    title: 'Booker T. Washington High School',
    subtitle: '',
    imageUrl: BookerT,
    description: 'Booker T. Washington High School\nPresident: Emma Hwang',
    'data-id': 'booker-t-washington'
  },
  {
    title: 'Plano West Senior High School',
    subtitle: '',
    imageUrl: PlanoWest,
    description: 'Plano West Senior High School\nPresident: Piyush Kumar',
    'data-id': 'plano-west'
  },
  {
    title: 'The Hockaday School',
    subtitle: '',
    imageUrl: Hockaday,
    description: 'The Hockaday School\nPresident: Emma Lin',
    'data-id': 'hockaday'
  },
  {
    title: 'Allen High School',
    subtitle: '',
    imageUrl: Allen,
    description: 'Allen High School\nPresident: Zanir Tharwani',
    'data-id': 'allen'
  },
  {
    title: 'Ranchview High School',
    subtitle: '',
    imageUrl: Ranchview,
    description: 'Ranchview High School\nPresident: Tarun Kumar Vijay',
    'data-id': 'ranchview'
  },
  {
    title: 'Green Level High School',
    subtitle: '',
    imageUrl: GreenLevel,
    description: 'Green Level High School\nPresident: Srinivas Tirunagari',
    'data-id': 'green-level'
  },
  {
    title: 'Centennial High School',
    subtitle: '',
    imageUrl: Centennial,
    description: 'Centennial High School\nPresident: Adhvaith Ananth',
    'data-id': 'centennial'
  },
  {
    title: 'Paramus High School',
    subtitle: '',
    imageUrl: Paramus,
    description: 'Paramus High School\nPresident: Ayush Patel',
    'data-id': 'paramus'
  },
  {
    title: 'Heritage High School',
    subtitle: '',
    imageUrl: Heritage,
    description: 'Heritage High School\nPresident: Moksha Paramathmuni\nVice Presidents: Lindsey Zhao, Ashwini',
    'data-id': 'heritage'
  },
  {
    title: 'Vines High School',
    subtitle: '',
    imageUrl: Vines,
    description: 'Vines High School\nCo-Presidents: Craig Benson, Fiona Bolt',
    'data-id': 'vines'
  },
  {
    title: 'Liberty High School',
    subtitle: '',
    imageUrl: Liberty,
    description: 'Liberty High School\nCo-Presidents: Ariesha Chitre, Aditri Pandey',
    'data-id': 'liberty'
  },
  {
    title: 'Independence High School',
    subtitle: '',
    imageUrl: Independence,
    description: 'Independence High School\nCo-Presidents: Kalaanidhi Sundar, Sumukh Chetan',
    'data-id': 'independence'
  },
  {
    title: 'Evergreen Valley High School',
    subtitle: '',
    imageUrl: Evergreen,
    description: 'Evergreen Valley\nCo-Presidents: Isha Singh, Noor Mandair',
    'data-id': 'evergreen-valley'
  },
  {
    title: 'Panther Creek High School',
    subtitle: '',
    imageUrl: PantherCreek,
    description: 'Panther Creek High School\nCo-Presidents: Srika Penmatsa, Aishwarya Das',
    'data-id': 'panther-creek'
  },
  {
    title: 'Lone Star High School',
    subtitle: '',
    imageUrl: LoneStar,
    description: 'Lone Star High School\nCo-Presidents: Melonie Vu, Yena Oh',
    'data-id': 'lone-star'
  },
   {
    title: 'Rock Hill High School',
    subtitle: '',
    imageUrl: ComingSoon,
    description: 'Rock Hill High School\nPresident: Deethya Gani',
    'data-id': 'rock-hill'
  },
  {
    title: 'Williams High School',
    subtitle: '',
    imageUrl: ComingSoon,
    description: 'Williams High School\nPresident: Grace Jobe',
    'data-id': 'williams'
  },
  {
    title: 'Jasper High School',
    subtitle: '',
    imageUrl: ComingSoon,
    description: 'Jasper High School\nPresident: Sampada Bapat',
    'data-id': 'jasper'
  },
  {
    title: 'Coppell High School',
    subtitle: '',
    imageUrl: Coppell,
    description: 'Coppell High School\nCo-Presidents: Kavya Karthik, Sanchi Srivastava',
    'data-id': 'coppell'
  },
  {
    title: 'Laguna Creek High School',
    subtitle: '',
    imageUrl: LagunaCreek,
    description: 'Laguna Creek High School\nCo-Presidents: Vevean Nguyen, Nguyen Nguyen',
    'data-id': 'laguna-creek'
  },
  {
    title: 'Wakeland High School',
    subtitle: '',
    imageUrl: Wakeland,
    description: 'Wakeland High School\nPresident: Shreya Goyle',
    'data-id': 'wakeland'
  },
  {
    title: 'Wylie East High School',
    subtitle: '',
    imageUrl: WylieEast,
    description: 'Wylie East High School\nPresident: Shayaan Younas',
    'data-id': 'wylie-east'
  },
  {
    title: 'William B Travis High School',
    subtitle: '',
    imageUrl: WilliamB,
    description: 'William B. Travis\nPresident: Beloo Niguse', 
  },
  {
    title: 'Minnesota Connections Academy',
    subtitle: '',
    imageUrl: Minnesota,
    description: 'Minnesota Connections Academy\nPresident: Makayla Anderson',
    'data-id': 'minnesota-connections',
  },
  

]
    
    return(
        <div>
            <h1 className="gradient-text-chapters">Our Chapters</h1>
            <CardList cards={schoolCards} />
        </div>
    )
}